var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "container_box" },
      [
        _c("pages-header", {
          ref: "pageHeader",
          attrs: {
            title: (_vm.type == 1 ? "编辑" : "添加") + "拼团活动",
            backUrl: "/marketing/group/activity",
          },
        }),
        _c(
          "el-card",
          {
            staticClass: "box-card box-body mt14 list-tabs",
            attrs: { shadow: "never", bordered: false },
          },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c("el-tab-pane", {
                  attrs: { label: "基础设置", name: "first" },
                }),
                _c("el-tab-pane", {
                  attrs: { label: "添加商品", name: "second" },
                }),
              ],
              1
            ),
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.formData, rules: _vm.rules, size: "small" },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "first",
                        expression: "activeName == 'first'",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "detailSection" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("基础信息"),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "活动名称：",
                              "label-width": "100px",
                              prop: "groupName",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "from-ipt-width",
                              attrs: {
                                placeholder: "请输入活动名称",
                                maxlength: 20,
                              },
                              model: {
                                value: _vm.formData.groupName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "groupName", $$v)
                                },
                                expression: "formData.groupName",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                "用于管理员区分活动，用户端不展示，最多输入20个字"
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "活动时间：",
                              "label-width": "100px",
                              prop: "startTime",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticClass: "selWidth",
                              attrs: {
                                type: "datetimerange",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "default-time": ["00:00:00", "23:59:59"],
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                clearable: false,
                              },
                              on: {
                                change: _vm.timeChange,
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                              model: {
                                value: _vm.time,
                                callback: function ($$v) {
                                  _vm.time = $$v
                                },
                                expression: "time",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "group-num-box",
                            attrs: {
                              label: "成团人数：",
                              "label-width": "100px",
                              prop: "buyCount",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "from-ipt-width group-num-box",
                              attrs: {
                                min: 2,
                                max: 5,
                                type: "number",
                                controls: false,
                                precision: 0,
                              },
                              model: {
                                value: _vm.formData.buyCount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "buyCount", $$v)
                                },
                                expression: "formData.buyCount",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v("请填写2～5的整数"),
                            ]),
                            _c("span", { staticClass: "span" }, [_vm._v("人")]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "group-num-box",
                            attrs: {
                              label: "成团有效期：",
                              "label-width": "100px",
                              prop: "validHour",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "from-ipt-width",
                              attrs: {
                                type: "number",
                                controls: false,
                                min: 1,
                                max: 240,
                                precision: 0,
                              },
                              model: {
                                value: _vm.formData.validHour,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "validHour", $$v)
                                },
                                expression: "formData.validHour",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                " 设置拼团的有效时间（请输入1～240的整数），用户开团后，需要在设置的时间内拼购指定人数，否则拼团失败，拼团失败系统自动退款。 "
                              ),
                            ]),
                            _c("span", { staticClass: "span time" }, [
                              _vm._v("小时"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "活动限购：",
                              "label-width": "100px",
                              prop: "allQuota",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "from-ipt-width",
                              attrs: {
                                min: 0,
                                max: 9999,
                                type: "number",
                                controls: false,
                                precision: 0,
                              },
                              model: {
                                value: _vm.formData.allQuota,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "allQuota", $$v)
                                },
                                expression: "formData.allQuota",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                " 请填写0～9999的整数，填0代表不限购；例如设置为4，表示本活动每个商品，每个用户最多可购买4件。 "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "单次限购：",
                              "label-width": "100px",
                              prop: "oncQuota",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "from-ipt-width",
                              attrs: {
                                min: 0,
                                max: 9999,
                                type: "number",
                                controls: false,
                                precision: 0,
                              },
                              model: {
                                value: _vm.formData.oncQuota,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "oncQuota", $$v)
                                },
                                expression: "formData.oncQuota",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                " 请填写0～9999的整数，填0代表不限购；例如设置为2，表示每次参与拼团时，用户一次购买数量最大可选择2件。 "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "团长佣金比例：",
                              "label-width": "100px",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "from-ipt-width",
                              attrs: {
                                min: 0,
                                max: 100,
                                type: "number",
                                controls: false,
                                precision: 2,
                              },
                              model: {
                                value: _vm.formData.leaderCommissionRate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "leaderCommissionRate",
                                    $$v
                                  )
                                },
                                expression: "formData.leaderCommissionRate",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "span",
                                staticStyle: { left: "430px" },
                              },
                              [_vm._v("%")]
                            ),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                " 团长佣金比例，填0表示不给团长佣金；例如设置为5，表示团长可获得订单金额5%的佣金。 "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("高级设置"),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "凑团：", "label-width": "100px" },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": "开启",
                                "inactive-text": "关闭",
                                width: 35,
                              },
                              on: { change: _vm.showGroup },
                              model: {
                                value: _vm.showGroupSwitch,
                                callback: function ($$v) {
                                  _vm.showGroupSwitch = $$v
                                },
                                expression: "showGroupSwitch",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                " 开启凑团后，活动商品详情页会显示待成团的团列表，买家可以直接任选一个参团，提升成团率。 "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showGroupSwitch,
                                expression: "showGroupSwitch",
                              },
                            ],
                            attrs: {
                              label: "虚拟成团：",
                              "label-width": "100px",
                            },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": "开启",
                                "inactive-text": "关闭",
                                width: 35,
                              },
                              on: { change: _vm.fictiStatus },
                              model: {
                                value: _vm.fictiStatusSwitch,
                                callback: function ($$v) {
                                  _vm.fictiStatusSwitch = $$v
                                },
                                expression: "fictiStatusSwitch",
                              },
                            }),
                            _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                " 开启虚拟成团后，该团有效期结束时，人数未满的团，系统将会虚拟“匿名买家”凑满人数，使该团成团。只有已付款参团的真实买家才会获得商品，建议合理开启，以提高成团率. "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "second",
                        expression: "activeName == 'second'",
                      },
                    ],
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addGoods },
                      },
                      [_vm._v("添加活动商品")]
                    ),
                    _vm._l(_vm.productList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "table-box" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "red-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteGoods(index)
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "iconfont icon-shanchu",
                              }),
                            ]
                          ),
                          _c("div", { staticClass: "detailHead" }, [
                            _c("div", { staticClass: "full" }, [
                              _c("i", {
                                staticClass: "iconfont iconChange",
                                class: item.visible
                                  ? "icon-xuanze"
                                  : "icon-xiala1",
                                on: {
                                  click: function ($event) {
                                    return _vm.openClose(item)
                                  },
                                },
                              }),
                              _c("img", {
                                attrs: { src: item.image, alt: "" },
                              }),
                              _c("div", { staticClass: "text" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "title line1",
                                    attrs: { title: item.name },
                                  },
                                  [_vm._v(" " + _vm._s(item.name) + " ")]
                                ),
                              ]),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        "append-to-body": false,
                                        placement: "bottom",
                                        trigger: "click",
                                        width: "300",
                                      },
                                      model: {
                                        value: item.priceVisible,
                                        callback: function ($$v) {
                                          _vm.$set(item, "priceVisible", $$v)
                                        },
                                        expression: "item.priceVisible",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "acea-row row-middle" },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              type: "number",
                                              placeholder: "请输入拼团价",
                                            },
                                            model: {
                                              value: item.inputPrice,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "inputPrice",
                                                  $$v
                                                )
                                              },
                                              expression: "item.inputPrice",
                                            },
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "ml14",
                                              attrs: { size: "mini" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.colosePrice(item)
                                                  item.priceVisible = false
                                                },
                                              },
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.setActivePrice(
                                                    item,
                                                    item.inputPrice
                                                  )
                                                  item.priceVisible = false
                                                },
                                              },
                                            },
                                            [_vm._v("确定")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "mr10",
                                          attrs: {
                                            slot: "reference",
                                            size: "small",
                                          },
                                          slot: "reference",
                                        },
                                        [_vm._v("设置拼团价")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        "append-to-body": false,
                                        width: "375",
                                        placement: "bottom",
                                      },
                                      model: {
                                        value: item.numVisible,
                                        callback: function ($$v) {
                                          _vm.$set(item, "numVisible", $$v)
                                        },
                                        expression: "item.numVisible",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "acea-row row-middle" },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              type: "number",
                                              placeholder: "请输入拼团限量",
                                            },
                                            model: {
                                              value: item.inputNum,
                                              callback: function ($$v) {
                                                _vm.$set(item, "inputNum", $$v)
                                              },
                                              expression: "item.inputNum",
                                            },
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "ml14",
                                              attrs: { size: "mini" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.coloseNum(item)
                                                  item.numVisible = false
                                                },
                                              },
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.setQuotaShow(
                                                    item,
                                                    item.inputNum
                                                  )
                                                  item.numVisible = false
                                                },
                                              },
                                            },
                                            [_vm._v("确定")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "mr10",
                                          attrs: {
                                            slot: "reference",
                                            size: "small",
                                          },
                                          slot: "reference",
                                        },
                                        [_vm._v("设置拼团限量")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          !item.visible
                            ? _c(
                                "div",
                                { staticClass: "tablelHead" },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      ref: "tableList",
                                      refInFor: true,
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "row-key": "id",
                                        data: item.attrValue,
                                        size: "small",
                                        "default-expand-all": "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: { width: "30" },
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "图片" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("img", {
                                                    attrs: {
                                                      src: scope.row.image,
                                                      alt: "",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "规格", prop: "sku" },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "商品编码",
                                          prop: "barCode",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "售价（元）",
                                          prop: "price",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "剩余库存",
                                          prop: "stock",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "拼团价（元）" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return scope.row.sku
                                                  ? [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          type: "number",
                                                          min: 0.01,
                                                          max: 999999.99,
                                                          controls: false,
                                                          precision: 2,
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .activePrice,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "activePrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.activePrice",
                                                        },
                                                      }),
                                                    ]
                                                  : undefined
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: { label: "拼团限量" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return scope.row.sku
                                                  ? [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          min: 0,
                                                          max: scope.row.stock,
                                                          type: "number",
                                                          controls: false,
                                                          precision: 0,
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.quotaShow,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "quotaShow",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.quotaShow",
                                                        },
                                                      }),
                                                    ]
                                                  : undefined
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "el-card",
          {
            staticClass: "fixed-card",
            attrs: { "dis-hover": "", shadow: "never", bordered: false },
          },
          [
            _c(
              "div",
              { staticClass: "acea-row row-center-wrapper" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "second",
                        expression: "activeName == 'second'",
                      },
                    ],
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.activeName = "first"
                      },
                    },
                  },
                  [_vm._v("上一步")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "first",
                        expression: "activeName == 'first'",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.toGo("form")
                      },
                    },
                  },
                  [_vm._v("下一步")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "second",
                        expression: "activeName == 'second'",
                      },
                      {
                        name: "debounceClick",
                        rawName: "v-debounceClick",
                        value: function () {
                          _vm.submitForm("form")
                        },
                        expression:
                          "\n            () => {\n              submitForm('form');\n            }\n          ",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                  },
                  [_vm._v("提交")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }